import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { DateModel } from 'src/app/models/inputs/date-model';

const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';

@Pipe({
  name: 'dateTranslate'
})
export class DateTranslatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value: any, format?: string): string {
    // Log.debug('new', new Date());
    // Log.debug('old', new Date('2019-05-18T10:06:03.820+0000'));
    let date;
    let dateStr = '';

    if (value) {
      if (value instanceof Date) {
        date = moment(value);
      } else if (value instanceof DateModel || typeof value === 'object') {
        date = moment(new Date(
          value.year as number - (this.translate.currentLang === 'en' ? 0 : 543),
          value.month as number - 1,
          value.day as number));
      } else if (typeof value === 'number') {
        try {
          date = moment(new Date(value));
        } catch (e) {
          date = null;
        }
      } else if (typeof value === 'string') {
        try {
          date = moment(new Date(value.substr(0, 10)));
        } catch (e) {
          date = null;
        }
      }

      if (date != 'Invalid Date') {
        date = this.translate.currentLang === 'th' ? date.add(543, 'year') : date;
        dateStr = date.format(format ? format : DATE_FORMAT_DEFAULT);
      }
    }

    return date == 'Invalid Date' ? value : dateStr;
  }

}
